/**
 * Range language varies based on whether a field is a text or a number.  This
 * method returns an appropriate suffix to apply to a message resource bundle
 * key prefix to get the full resource bundle key for a message.
 *
 * @param dataType the dataType of the field
 * @returns {string} the suffix
 */

import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT } = DataType

function rangeKeySuffix(dataType) {
	return '.' + (dataType === TEXT ? TEXT : 'numeric')
}

export default rangeKeySuffix

rangeKeySuffix.__filename__ = 'datasets/edit/range-key-suffix.js'
